import { render, staticRenderFns } from "./AreaEmbargadaRo.vue?vue&type=template&id=4e7eb7f0&lang=pug"
import script from "./AreaEmbargadaRo.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaRo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports